import * as React from 'react'

import { TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface Props {
  field: Field
}

const WorkPermit = (props: Props) => {
  const { field } = props

  return (
    <>
      <TogglerCheckbox
        value={field.value}
        onChange={(nextActive) => field.set(nextActive)}
        label={i18n.t('employee_form.work_permit.label')}
      />
    </>
  )
}

export default WorkPermit
